// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Ixrc","content":"styles_content__3WOce","row":"styles_row__3vLHl","footer":"styles_footer__3IlRe","phraseLength":"styles_phraseLength__24U-z"};